import { DelegatedStorageEngine } from './settingsReducer';

import type { changeUser } from '#/reduxState/currentUser/currentUserReducer';
import type {
  changeAnyWallet,
  removeWallet,
} from '#/reduxState/wallet/walletReducer';
import type { Reducer } from 'redux';

/** Warning: This might be cached in LocalStorage - be careful with changing */
export type DelegatedKeyAuthorization = {
  walletType: 'delegatedKey';

  custodyWalletAddress: string;
  walletAddress: string;
  walletAddressOriginal: string;
  privateKeyPersonalEncryption: 'personal1';

  delegatedKeyEncrypted: string;

  createdTime?: number;
  /** Time (ms) when last expiration notification was sent */
  lastRenewNoticeTime?: number;
};

const defaultState: DelegatedKeyAuthorization = {
  walletType: 'delegatedKey',
  custodyWalletAddress: '',
  walletAddress: '',
  walletAddressOriginal: '',
  privateKeyPersonalEncryption: 'personal1',
  delegatedKeyEncrypted: '',
  createdTime: undefined,
  lastRenewNoticeTime: undefined,
};

// Actions

export const setDelegatedKey = (
  storageEngine: DelegatedStorageEngine,
  delegatedKey: DelegatedKeyAuthorization
) => ({
  type: 'SET_DELEGATED_KEY' as const,
  delegatedKey,
  storageEngine,
});

/** Renew/expired notification of last banner */
export const delegatedKeyUpdateNotified = () => ({
  type: 'DELEGATED_KEY_NOTIFY' as const,
});

export const dev_delegatedKeyMoveCreated = (days: number) => ({
  type: 'DEV_DELEGATED_KEY_MOVE_CREATED' as const,
  days,
});

export const dev_delegatedKeyResetLastNotify = () => ({
  type: 'DEV_DELEGATED_KEY_RESET_LAST_NOTIFY' as const,
});

// export function removeDelegatedKey() {
//   return {
//     type: 'REMOVE_DELEGATED_KEY' as const,
//   };
// }

type Actions =
  | ReturnType<
      | typeof changeUser
      | typeof setDelegatedKey
      | typeof removeWallet
      | typeof delegatedKeyUpdateNotified
      | typeof dev_delegatedKeyMoveCreated
      | typeof dev_delegatedKeyResetLastNotify
      // | typeof removeDelegatedKey
    >
  | changeAnyWallet;

// Reducer @cached in standalone local or session storage, see caching.ts */

export const delegatedKeyAuthorizationReducer: Reducer<
  DelegatedKeyAuthorization,
  Actions
> = (state = defaultState, action): DelegatedKeyAuthorization => {
  switch (action.type) {
    case 'CHANGE_USER':
      if (action.loggedIn === false) {
        // Note that when user is removed, eg. session removed/expired/logged out in another tab,
        // we want to remove user wallet too...
        return defaultState;
      }
      return state;
    case 'CHANGE_WALLET':
    case 'REMOVE_WALLET':
      // case 'REMOVE_DELEGATED_KEY':
      return defaultState;
    case 'SET_DELEGATED_KEY':
      return action.delegatedKey;
    case 'DELEGATED_KEY_NOTIFY':
      return {
        ...state,
        lastRenewNoticeTime: Date.now(),
      };
    case 'DEV_DELEGATED_KEY_RESET_LAST_NOTIFY':
      return {
        ...state,
        lastRenewNoticeTime: 0,
      };
    case 'DEV_DELEGATED_KEY_MOVE_CREATED':
      return {
        ...state,
        createdTime:
          (state.createdTime || Date.now()) -
          1000 * 60 * 60 * (24 * action.days),
      };
    default:
      return state;
  }
};
